// Mixins
import { toastMessageMixins } from '@/app/mixins/utils/toast-message-mixins';

// Util
import { vuelidateUtil } from '@/utils/vuelidate-util.js';

// Third Party libraries
import * as $ from 'jquery';

// Constants
import { STATUS_CODES } from '@/app/constants/status-constants';

// Services
import ClubService from '@/app/services/main/club/club-service.js';

export default {
    name: 'ModalSocialCreateGroup',
    mixins: [
        toastMessageMixins
    ],
    data() {
        return {
			groupName: '',
			isAPILoading: false
        }
    },
    computed: {
        validationRules() {
            let field = {
                groupName: {}
            };

            field = vuelidateUtil.setRequiredValidation(field, 'groupName');

            return field;
        }
    },
    beforeDestroy() {
        this.closeModal();
    },
    methods: {
        openModal() {
            this.groupName = '';
            
	        this.$v.$reset();
            $(this.$refs.createGroupModal).modal('show');
        },
        closeModal() {
	        $(this.$refs.createGroupModal).modal('hide');
        },
        submitGroupName() {
            if (this.$v.$invalid) {
                return;
            }

            const reqBody =  { 
                name: this.groupName
            }

            this.isAPILoading = true;

            // call create group endpoint
            ClubService.socialCreateGroup(reqBody)
                .then(res => {
                    if (res.status === STATUS_CODES.SUCCESS) {
                        this.showCustomSuccessToast(null, `Group ${this.groupName} succcesfully created`);
                        this.$store.commit('setActiveGroup', { 
                            id: res.data,
                            name: this.groupName,
                            access: 'CC',
                            memberStatus: 'A'
                        });

                        this.closeModal();
                    } else {
                        this.showCustomErrorToast(res.data.errors[0].message, null, true);
                    }

                    this.isAPILoading = false;
                })
                .catch(() => {
                    this.showGenericErrorToast();
                    this.isAPILoading = false;
                });
        }
    },
    validations() {
        return this.validationRules;
    }
}